
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ILandingShortOrder } from '@/interfaces'
import { dispatchSubmitLandingOrder, dispatchValidatePromocode } from '@/store/main/actions'
import Spinner from '@/components/Spinner.vue'

@Component({
	components: {
		Spinner,
	}
})

export default class LndPopupCheckout extends Vue {
	// props
	@Prop({ default: false }) readonly promocode!: string

	public order: ILandingShortOrder = {
		email: '',
		code: '',
	}

	public loading: boolean = false

	public formError: boolean = false
	public emailExists: boolean = false
	public promocodeValid: boolean = true

    public haveAKey: boolean = true

	get validateForm() {
		this.formError = !this.order.email || !this.order.code

		return !this.formError
	}

  	public async handleUpdatePromocode() {
		console.debug('%c handleUpdatePromocode(%s)', 'color:magenta;font-size:18px;', this.order.code)

		const response = await dispatchValidatePromocode(
			this.$store, {
				code: this.order.code,
			},
		);

		if (!response) {
			this.promocodeValid = false
		}
  	}

    public handleHaveAKeyChange() {
        this.haveAKey = !this.haveAKey;

        if (!this.haveAKey) {
            this.order.code = 'X1JOIN';
            this.promocodeValid = true;
        } else {
            this.order.code = '';
        }
    }

	public async handleSubmit() {
		if (this.loading) return

		console.log('%c handleSubmit(%s)', 'color:gold;', JSON.stringify(this.order, null, 4));

		if (this.validateForm) {
			this.emailExists = false;
			this.loading = true

			const response = await dispatchSubmitLandingOrder(this.$store, this.order);

			if (response.status === 200 || response.status === 201) {
				window.open(
					`${window.location.href.includes('stage') || window.location.href.includes('localhost') ? 'https://stage.app.x1ecochain.com' : 'https://app.x1ecochain.com/'}?auth-token=${response.data.token}&promocode=${this.haveAKey ? this.order.code : ''}`,
					'_blank',
				)
			} else if (response.status === 400) {
				if (response.data.email) {
					// this.$toast.error(this.$t('Email is already exists').toString());
					this.emailExists = true;
				} else {
					// this.$toast.error(this.$t('Error').toString());
					this.promocodeValid = false
				}
			} else {
				// this.$toast.error(this.$t('Error').toString());
			}

			this.loading = false
		}
	}

	mounted() {
		if (this.promocode) {
			this.order.code = this.promocode
			this.handleUpdatePromocode()
		} else {
			this.order.code = ''
		}
	}
}
